/**
 * @typedef {Object} toothModel
 * @property {string} toothGumType - The type of tooth gum (UPPER or LOWER)
 * @property {number} toothNumber - The tooth number
 * @property {number} toothIndex - The tooth index
 * @property {string} model - The model of the tooth
 */

import { mergeVertices } from "three/examples/jsm/utils/BufferGeometryUtils.js";
import { TOOTH_NUMBER_KEY } from "../constant/toothConstant";
import toothDB from "../db/toothDB";
import toothNumberDB from "../db/toothNumberDB";
import { modelLoad } from "../util/modelLoader";
import { addPerform } from "../../tools/perform-tool";

/**
 * @type {toothModel[]}
 */
const toothModelListSingle = [];

const toothModelMapSingle = {};

const loadToothModel = async (toothDOList) => {
  const toothModelPromiseList = toothDOList.map((toothDO) => {
    return modelLoad(toothDO.fileUrl, toothDO.filePath);
  });
  const toothModelResultList = await Promise.all(toothModelPromiseList);

  const toothModelResultListWithNormal = toothModelResultList.map((model) => {
    model.deleteAttribute("normal");
    const newModel = mergeVertices(model, 0.1);
    newModel.computeVertexNormals(true);
    return newModel;
  });
  return toothModelResultListWithNormal;
};

const loadToothModelList = async () => {
  const toothDOList = toothDB.getToothDOList();

  const toothModelResultList = await loadToothModel(toothDOList);

  for (let i = 0; i < toothDOList.length; i++) {
    const toothDO = toothDOList[i];
    const { toothGumType, toothIndex } = toothDO;
    const toothNumber = toothNumberDB.getToothNumberByGumTypeAndToothIndex(
      toothGumType,
      toothIndex
    );

    if (!toothNumber || !toothIndex || !toothGumType) {
      throw new Error(
        `Tooth number not found for toothGumType: ${toothGumType}, toothIndex: ${toothIndex}`
      );
    }

    const toothModel = {
      toothGumType,
      toothNumber,
      toothIndex,
      model: toothModelResultList[i],
    };

    toothModelMapSingle[`${TOOTH_NUMBER_KEY}:${toothNumber}`] = toothModel;
    toothModelListSingle.push(toothModel);
  }
};

const getToothModelByToothNumber = (toothNumber) => {
  return toothModelMapSingle[`${TOOTH_NUMBER_KEY}:${toothNumber}`];
};

const getToothModelList = () => {
  return toothModelListSingle;
};

export default {
  loadToothModelList,
  getToothModelByToothNumber,
  getToothModelList,
};
